import React, { useEffect, useState } from "react";
import "./style.css";
import { Link, useLocation } from "react-router-dom";
import DownArrow from "../../assets/img/down_arrow.svg";
import DoubleUpArrow from "../../assets/img/CaretDoubleUp.svg";
import ChanakyaLogo from "../../assets/img/chanakyaLogo.svg";

const Header = ({
  scrollToSection,
  mobNav,
  setMobNav,
  setMobNavbar,
  mobNavbar,
  rightBtnText,
  rightBtnLink,
  handleDownloadAppButtonClick,
}) => {
  const location = useLocation();
  const [deviceType, setDeviceType] = useState("");
  const isBlogsPage = location?.pathname === "/blogs" || location?.pathname.startsWith("/blog/");
  // const isHowItWorksPage = location?.pathname === "/how-it-works";
  const isChatPage = location?.pathname === "/chat";
  const isAboutUsPage = location?.pathname === "/about-us";
  const is404Page = !location.pathname.match(/^\/(privacy|tos|refundpolicy|blog\/.*|blogs|chat|about-us|edu-business|careers|how-it-works)$/) && location.pathname !== "/";

  const handleMobileNav = () => {
    if (location?.pathname === "/privacy" || location?.pathname === "/tos" || location?.pathname === "/refundpolicy") {
      setMobNavbar(!mobNavbar);
    } else {
      setMobNav(!mobNav);
    }
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    if (/window phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/Win/i.test(userAgent)) {
      return "Windows";
    }

    return "unknown";
  };

  useEffect(() => {
    const device = getDeviceType();
    setDeviceType(device);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <header className="header">
        <nav className="nav navbar-nav">
          <div className="header-logo">
            <Link to="/" className="logo" onClick={scrollToTop}>
              <img src={ChanakyaLogo} alt="" width="120" height="40" />
            </Link>
          </div>
          <div className="navbar-links">
            <ul className="nav-list">
              {location?.pathname === "/privacy" ||
              location?.pathname === "/tos" ||
              location?.pathname === "/refundpolicy" ||
              is404Page ? (
                ""
              ) : (
                <>
                  {(location?.pathname === "/chat" || isBlogsPage) && (
                    <li className="nav-items">
                      <Link to="/" className="nav-link">
                        Home
                      </Link>
                    </li>
                  )}
                  {!isAboutUsPage && (
                    <li className="nav-items">
                      <Link to="/about-us" className="nav-link" onClick={handleMobileNav}>
                        About Us
                      </Link>
                    </li>
                  )}
                  <li className="nav-items dropdown">
                    {/* <span className="nav-link">
                      Products
                    </span> */}
                    <div className="dropdown-content">
                      <Link to="/" className="dropdown-item">
                        <div className="dropdown-item-content">
                          <h4>Chanakya Assessments</h4>
                          <p>AI-powered assessments for better learning outcomes</p>
                        </div>
                      </Link>
                      <Link to="/chat" className="dropdown-item">
                        <div className="dropdown-item-content">
                          <h4>Chanakya AI Bot</h4>
                          <p>Your personal AI tutor for instant help</p>
                        </div>
                      </Link>
                    </div>
                  </li>
                  {!isBlogsPage && (
                    <li className="nav-items">
                      <Link to="/blogs" className="nav-link">
                        Blogs
                      </Link>
                    </li>
                  )}
                  {/* {isBlogsPage && !isHowItWorksPage && (
                    <li className="nav-items">
                      <Link to="/how-it-works" className="nav-link">
                        How Chanakya AI Works
                      </Link>
                    </li>
                  )} */}
                  {!isBlogsPage ? (
                    <>
                      <li className="nav-items">
                        <button
                          onClick={() => scrollToSection("explore")}
                          className="nav-link"
                        >
                          Explore AI
                        </button>
                      </li>
                      <li className="nav-items">
                        <button
                          onClick={() => scrollToSection("pricing")}
                          className="nav-link"
                        >
                          Pricing
                        </button>
                      </li>
                      <li className="nav-items">
                        <button
                          onClick={() => scrollToSection("faq")}
                          className="nav-link"
                        >
                          FAQ'S
                        </button>
                      </li>
                    </>
                  ) : (
                    <li className="nav-items">
                      <Link to="/" className="nav-link" onClick={(e) => {
                        e.preventDefault();
                        // Use hash fragment for direct navigation to pricing section
                        window.location.href = '/#pricing-section';
                      }}>
                        Pricing
                      </Link>
                    </li>
                  )}
                  {location?.pathname !== "/chat" && !isBlogsPage && (
                    <>
                      <li className="nav-items">
                        <Link to="/edu-business" className="nav-link">
                          For Institutes
                        </Link>
                      </li>
                      <li className="nav-items">
                        <Link to="https://exams.aichanakya.in/" className="nav-link">
                          Sign in
                        </Link>
                      </li>
                    </>
                  )}
                  {location?.pathname !== "/chat" && !isBlogsPage && (
                    <li>
                      <Link to="/chat" className="nav-link">
                        Chanakya AI Bot
                      </Link>
                    </li>
                  )}
                </>
              )}
              <li className="nav-items">
                {rightBtnLink ? (
                  <a
                    href={rightBtnLink}
                    target="_blank"
                    rel="noreferrer"
                    className="btn download-btn"
                  >
                    {rightBtnText}
                  </a>
                ) : isChatPage ? (
                  <a
                    href={
                      deviceType === "Windows"
                        ? "https://chat.aichanakya.in/"
                        : deviceType === "Android"
                        ? "https://play.google.com/store/apps/details?id=tech.neurobridge.chanakya"
                        : deviceType === "iOS"
                        ? "https://apps.apple.com/us/app/chanakya-ai/id6504797681"
                        : "/"
                    }
                    target="_blank"
                    rel="noreferrer"
                    className="btn download-btn"
                    onClick={handleDownloadAppButtonClick}
                  >
                    {"Download App"}
                  </a>
                ) : (
                  <a
                    href="https://calendly.com/atharv-gyem/discovery-call"
                    target="_blank"
                    rel="noreferrer"
                    className="btn download-btn"
                    onClick={handleDownloadAppButtonClick}
                  >
                    {"Start Learning"}
                  </a>
                )}
              </li>
            </ul>
            {mobNav ? (
              <button className="close-nav" onClick={handleMobileNav}>
                <img src={DoubleUpArrow} alt="icon" width="16" height="16" />
              </button>
            ) : (
              <button className="toggle-btn" onClick={handleMobileNav}>
                <span></span>
              </button>
            )}
          </div>
        </nav>
      </header>
      <div
        className={`mobileNav-wrapper ${mobNav || mobNavbar ? "active" : ""}`}
      >
        <ul className="mobileNav-list">
          {location?.pathname === "/privacy" ||
          location?.pathname === "/tos" ||
          location?.pathname === "/refundpolicy" ||
          is404Page ? (
            ""
          ) : (
            <>
              {(location?.pathname !== "/" || isBlogsPage) && (
                <li className="mobileNav-item">
                  <Link to="/" className="mob-nav-btn">
                    Home
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              {!isAboutUsPage && (
                <li className="mobileNav-item">
                  <Link to="/about-us" className="mob-nav-btn" onClick={handleMobileNav}>
                    About Us
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              <li className="mobileNav-item dropdown">
                {/* <span className="mob-nav-btn">
                  Products
                </span> */}
                <div className="dropdown-content">
                  <Link to="/" className="dropdown-item" onClick={handleMobileNav}>
                    Chanakya Assessments
                  </Link>
                  <Link to="/chat" className="dropdown-item" onClick={handleMobileNav}>
                    Chanakya AI Bot
                  </Link>
                </div>
              </li>
              {!isBlogsPage && (
                <li className="mobileNav-item">
                  <Link to="/blogs" className="mob-nav-btn" onClick={handleMobileNav}>
                    Blogs
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              {/* {isBlogsPage && !isHowItWorksPage && (
                <li className="mobileNav-item">
                  <Link to="/how-it-works" className="mob-nav-btn" onClick={handleMobileNav}>
                    How Chanakya AI Works
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )} */}
              {!isBlogsPage ? (
                <>
                  <li className="mobileNav-item">
                    <button
                      type="button"
                      className="mob-nav-btn"
                      onClick={() => {
                        handleMobileNav();
                        setTimeout(() => scrollToSection("explore"), 300);
                      }}
                    >
                      Explore AI
                      <img src={DownArrow} alt="icon" width="12" height="12" />
                    </button>
                  </li>
                  <li className="mobileNav-item">
                    <button
                      type="button"
                      className="mob-nav-btn"
                      onClick={() => {
                        handleMobileNav();
                        setTimeout(() => scrollToSection("pricing"), 300);
                      }}
                    >
                      Pricing
                      <img src={DownArrow} alt="icon" width="12" height="12" />
                    </button>
                  </li>
                  <li className="mobileNav-item">
                    <button
                      type="button"
                      className="mob-nav-btn"
                      onClick={() => {
                        handleMobileNav();
                        setTimeout(() => scrollToSection("faq"), 300);
                      }}
                    >
                      FAQs
                      <img src={DownArrow} alt="icon" width="12" height="12" />
                    </button>
                  </li>
                </>
              ) : (
                <li className="mobileNav-item">
                  <Link to="/" className="mob-nav-btn" onClick={(e) => {
                    e.preventDefault();
                    handleMobileNav();
                    window.location.href = '/#pricing-section';
                  }}>
                    Pricing
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              {location?.pathname !== "/chat" && !isBlogsPage && (
                <li className="mobileNav-item">
                  <Link to="/edu-business" className="mob-nav-btn" onClick={handleMobileNav}>
                    For Institutes
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              {location?.pathname !== "/chat" && !isBlogsPage && (
                <li className="mobileNav-item">
                  <Link to="/chat" className="mob-nav-btn">
                    Chanakya AI Bot
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </Link>
                </li>
              )}
              {location?.pathname !== "/chat" && !isBlogsPage && (
                <li className="mobileNav-item">
                  <a
                    href="https://exams.aichanakya.in/"
                    className="mob-nav-btn"
                    // onClick={handleMobileNav}
                  >
                    Sign In
                    <img src={DownArrow} alt="icon" width="12" height="12" />
                  </a>
                </li>
              )}
            </>
          )}
          <li className="mobileNav-item">
            {rightBtnLink ? (
              <a
                href={rightBtnLink}
                target="_blank"
                rel="noreferrer"
                className="mob-download-btn"
              >
                {rightBtnText}
              </a>
            ) : isChatPage ? (
              <a
                href={
                  deviceType === "Windows"
                    ? "https://chat.aichanakya.in/"
                    : deviceType === "Android"
                    ? "https://play.google.com/store/apps/details?id=tech.neurobridge.chanakya"
                    : deviceType === "iOS"
                    ? "https://apps.apple.com/us/app/chanakya-ai/id6504797681"
                    : "/"
                }
                target="_blank"
                rel="noreferrer"
                className="mob-download-btn"
                onClick={handleDownloadAppButtonClick}
              >
                {"Download App"}
              </a>
            ) : (
              <a
                href="https://calendly.com/atharv-gyem/discovery-call"
                target="_blank"
                rel="noreferrer"
                className="mob-download-btn"
                onClick={handleDownloadAppButtonClick}
              >
                {"Start Learning"}
              </a>
            )}
          </li>
        </ul>
      </div>
      <div
        className={`navback-drop ${mobNav || mobNavbar ? "show" : ""}`}
        onClick={handleMobileNav}
      ></div>
    </>
  );
};

export default Header;